import { render, staticRenderFns } from "./BusinessUnitsSelector.vue?vue&type=template&id=04be04bc&scoped=true&"
import script from "./BusinessUnitsSelector.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04be04bc",
  null
  
)

export default component.exports